import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';

class TextEditField extends Component {

    render() {

        return (
            <TextField
                placeholder={this.props.hintText}
                label={this.props.label}
                className='textfield'
                name={this.props.name}
                value={this.props.value}
                onChange={this.props.onChange}
                disabled={this.props.disabled}
                multiline={this.props.multiLine}
                rows={this.props.rows}
                fullWidth={this.props.fullWidth}
                {...this.props}
            />
        );
    }

}

export default TextEditField;
